import { gql } from "@apollo/client";

export const CreateGrid = gql`
    mutation CreateGrid ($gridViewId: ID!, $input: GridCreateAttributesInput!){
        createGrid (gridViewId: $gridViewId, input: $input) {
            id
            title
        }
    }
`;
